import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../firebase';
import Spinner from '../common/Spinner';

function PrivateRoute({ children, requiresToken = false }) {
  const [user, loading] = useAuthState(auth);
  const location = useLocation();

  // Verifica se há um token na URL
  const urlParams = new URLSearchParams(location.search);
  const token = urlParams.get('token');

  if (loading) return <Spinner />;

  // Verifica se a rota requer token e se ele está ausente
  if (requiresToken && !token) {
    return <Navigate to="/error" />;
  }

  // Verifica se a rota requer autenticação de usuário e o usuário não está autenticado
  if (!requiresToken && !user) {
    return <Navigate to="/login" />;
  }

  return children;
}

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
  requiresToken: PropTypes.bool,
};

export default PrivateRoute;
